const TableBody = ({children, style={}}) => {
    return (<tbody style={{...style}}>
        {children}
        </tbody>)
}

export default TableBody